import React from "react";
import OrderDetail from "components/Panel/Admin/OrderDetail";

const OrderDetailContainer = () => {
  return <OrderDetail />;
};

export default OrderDetailContainer;
